import { base58btc } from 'multiformats/bases/base58';
import { base64, base64pad, base64url, base64urlpad } from 'multiformats/bases/base64';
import { base32, base32hex, base32hexpad, base32hexpadupper, base32hexupper, base32pad, base32padupper, base32upper, base32z } from 'multiformats/bases/base32';
import { base16, base16upper } from 'multiformats/bases/base16';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const parseMultibase = /* @__PURE__ */ __name(async (multibase) => {
  const [prefix, ..._value] = multibase;
  const supportedBases = [
    base58btc,
    base64,
    base64pad,
    base64url,
    base64urlpad,
    base32,
    base32hex,
    base32hexpad,
    base32hexpadupper,
    base32hexupper,
    base32pad,
    base32padupper,
    base32upper,
    base32z,
    base16,
    base16upper
  ];
  const base = supportedBases.find((base2) => base2.prefix === prefix);
  if (!base) {
    throw new Error("Unsupported multibase");
  }
  return base.decode(multibase);
}, "parseMultibase");
const getDomain = /* @__PURE__ */ __name((domain) => {
  if (!domain || domain.trim() === "") {
    return void 0;
  }
  try {
    const parsedUrl = domain.startsWith("http") ? domain : "http://" + domain;
    const url = new URL(parsedUrl);
    if (!url.hostname.includes(".")) {
      return void 0;
    }
    return url.hostname + (url.pathname !== "/" ? url.pathname : "");
  } catch (error) {
    return void 0;
  }
}, "getDomain");

export { getDomain, parseMultibase };
